import PhoneIcon from '@mui/icons-material/Phone'
import { Box, Container, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import LoadingButtonForm from '../../shared/forms/LoadingButtonForm'
import {
  getError,
  getIsReceivedSms,
  getLoading,
  getMessage,
  phoneNumberSet,
  resetPassword,
  setError,
  setMessage,
} from '../../store/auth'

interface FormValues {
  phoneNumber: string
}

const initialValues: FormValues = { phoneNumber: '' }

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string().max(11).required().label('phone number'),
})

const ForgetPasswordScreen: React.FC = () => {
  const { t } = useTranslation()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch<Dispatch<any>>()
  const IsReceivedSms = useSelector(getIsReceivedSms)
  const loading = useSelector(getLoading)
  const navigate = useNavigate()
  const [phone, setPhone] = useState('')
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    // navigate(`/${routes.CARS}`)
  }, [message])
  const handleSubmit = (values: any) => {
    dispatch(resetPassword(values))
    setPhone(values)
    dispatch(phoneNumberSet(values.phoneNumber))
  }
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])
  useEffect(() => {
    if (IsReceivedSms === false) return
    navigate(`/${routes.CHANGE_PASSWORD}`, { state: { phoneNumber: phone } })
  }, [IsReceivedSms])

  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Box display='flex' justifyContent='center'>
          <img alt='Logo' src='images/Logo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1, direction: 'rtl' }}>
          <Typography sx={{ color: 'grey.700', fontSize: 19 }} variant='h5'>
            {t('screens.auth.forgetPassword.title')}
          </Typography>
        </Box>
        <Box sx={{ direction: 'ltr' }}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <FormField
              name='phoneNumber'
              placeholder={t('screens.auth.login.phone_number_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon />
                </InputAdornment>
              }
            />

            {/* <SubmitButton title={t('screens.auth.forgetPassword.restore_button_text')} /> */}
            <LoadingButtonForm loading={loading} title='ارسال' variant='contained' />
          </Form>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', direction: 'rtl' }}>
          <Button onClick={() => navigate(`/${routes.LOGIN}`, { replace: true })} variant='text'>
            {t('screens.auth.register.login_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default ForgetPasswordScreen
